import React from 'react'
import Container from 'react-bootstrap/Container'
import AboutService from '../services/AboutService'
import LoadingContainer from '../components/common/LoadingContainer'

export default function TermsOfUSe() {
  const [data, setData] = React.useState([])
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    getAboutPageData()
  }, [])
  const getAboutPageData = async () => {
    setLoading(true)
    try {
      const response = await AboutService.getTermsAndCondition()
      setData(response?.data || [])
      // console.log(response)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }
  return (
    <LoadingContainer loading={loading}>
      <Container className='py-5'>
        <h1 className='mb-4 text-center'>Terms of uses</h1>
        {data?.map((item, i) => (
          <div
            dangerouslySetInnerHTML={{ __html: item }}
            key={i}
            // className='dangerouslySetInnerHTML'
          />
        ))}
      </Container>
    </LoadingContainer>
  )
}
